import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const ChevronIcon = ({ open }) => (
  <svg
    className={`w-5 h-5 flex-shrink-0 text-brand-orange-500 transition-transform duration-300 ${
      open ? 'rotate-180' : ''
    }`}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
    aria-hidden="true"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
)

/**
 * Collapsed content stays in the DOM (hidden) so prerendered HTML includes
 * it for crawlers and FAQ rich results.
 */
const Disclosure = ({ title, children, defaultOpen = false, as: Heading = 'span' }) => {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className="border-t border-dark-300/40">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-4 py-4 text-left"
        aria-expanded={open}
      >
        <Heading className="font-display text-dark-700 text-base md:text-lg font-semibold">
          {title}
        </Heading>
        <ChevronIcon open={open} />
      </button>
      <AnimatePresence initial={false}>
        {open ? (
          <motion.div
            key="content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            className="overflow-hidden"
          >
            <div className="pb-5">{children}</div>
          </motion.div>
        ) : (
          <div key="hidden" hidden>
            {children}
          </div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default Disclosure
